export default __webpack_public_path__ + "static/media/Pickpocket's Boots of the Burning Temple.4db43d9b.jpg";